import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IFalg } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const AddFalgSlice = createSlice({
  name: "AddFalgSlice",
  initialState: {} as IReduxState<IFalg>,
  reducers: {
    addFalg: (state, _: PayloadAction<IFalg>) => {
      state.isLoading = true;
    },
    successaddFalg: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddFalg: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddFalgResponse: (state) => {
      state.data = {};
    },
  },
});

export const { addFalg, failureaddFalg, successaddFalg, clearAddFalgResponse } =
  AddFalgSlice.actions;

export default AddFalgSlice.reducer;
